import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpellCheckSuggestionsComponent } from './spell-check-suggestions.component';

@NgModule({
  declarations: [SpellCheckSuggestionsComponent],
  imports: [CommonModule],
  exports: [SpellCheckSuggestionsComponent],
  entryComponents: [SpellCheckSuggestionsComponent]
})
export class SpellCheckSuggestionsModule { }

